import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
            const response = await fetch(`${API_URL}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            if (response.ok) {
                login(data.user, data.token);
                // Redirect based on role
                if (data.user.role === 'client') {
                    navigate('/dashboard/client');
                } else if (data.user.role === 'employee') {
                    navigate('/dashboard/employee');
                } else {
                    navigate('/dashboard');
                }
            } else {
                setError(data.error || 'Login failed');
            }
        } catch (err) {
            setError('Something went wrong. Please try again.');
        }
    };

    return (
        <div className="login-page-wrapper">
            <div className="login-container">
                {/* Information Panel */}
                <div className="login-info-panel">
                    <div className="login-info-content">
                        <h2>Secure Portal Access</h2>
                        <p>
                            Welcome to the Observant Security private portal. This secure area is dedicated exclusively to our registered clients and employees.
                        </p>
                        <ul>
                            <li>Access confidential KPI & Analytics Dashboards</li>
                            <li>Review internal Policies & Compliance Handbooks</li>
                            <li>Submit direct feedback to management</li>
                            <li>View real-time operative performance data</li>
                        </ul>
                        <p style={{ marginTop: '30px', fontStyle: 'italic', fontSize: '0.9rem', color: '#rgba(255,255,255,0.7)' }}>
                            *Authentication is required to ensure data protection standards are met (BS7858).
                        </p>
                        <img src="/Sunnyday_Snapshots/site_image.jpeg" alt="Professional Security Services" style={{ width: '100%', borderRadius: '8px', marginTop: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.3)' }} />
                    </div>
                </div>

                {/* Form Panel */}
                <div className="login-form-panel">
                    <h2>Sign In</h2>
                    <p className="form-subtitle">Enter your credentials to access your dashboard</p>

                    {error && <div className="error-message">{error}</div>}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="name@company.com"
                            />
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <div className="password-input-wrapper">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    placeholder="••••••••"
                                />
                                <button
                                    type="button"
                                    className="password-toggle-btn"
                                    onClick={() => setShowPassword(!showPassword)}
                                    title={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                                            <line x1="1" y1="1" x2="23" y2="23"></line>
                                        </svg>
                                    ) : (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                            <circle cx="12" cy="12" r="3"></circle>
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>
                        <button type="submit" className="login-btn">Secure Login</button>
                    </form>

                    <div className="auth-links" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <Link to="/forgot-password" style={{ color: '#rgba(255,255,255,0.7)', fontSize: '0.9rem', textAlign: 'center' }}>Forgot Password?</Link>
                        <div>
                            Don't have an account? <Link to="/register">Request Access</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
